import React from "react";
import { LABELS } from "@/common/constants/constants";
import aboutCompanyDataFetch from "@/data/domain/about-company.json";
import { v4 as uuidv4 } from "uuid";

import styles from "./AboutCompanyNumbers.module.scss";

const AboutCompanyNumbers = () => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{LABELS.JOZYJOB_IN_NUMBERS}</h2>
      <div className={styles.cardsWrapper}>
        {aboutCompanyDataFetch?.numbers.map((item) => {
          return (
            <div className={styles.card} key={uuidv4()}>
              <h2 className={styles.cardValue}>{item.value}</h2>
              <div className={styles.cardTitle}>{item.title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AboutCompanyNumbers;
